import { observer } from 'mobx-react-lite'
import { DeleteJobDialog } from '@/features/jobs/details/components/DeleteJobDialog'
import { type DeleteJobDialogViewModel } from './DeleteJobDialogViewModel'

export interface DeleteJobDialogContainerProps {
  vm: DeleteJobDialogViewModel
}

export const DeleteJobDialogContainer = observer(
  function DeleteJobDialogContainer({ vm }: DeleteJobDialogContainerProps) {
    return (
      <DeleteJobDialog
        showing={vm.modal.showing}
        isDeletePending={vm.delete.pending}
        onClose={vm.modal.close}
        onDelete={vm.delete}
      />
    )
  },
)
